import React, { Component } from 'react';
import { Section, Heading } from 'components';
import './BlogName.scss';

class BlogName extends Component {
  render() {
    return (
      <Section
        color={'mine-shaft'}
        additionalClass={'blog-name'}
        containerClass={'blog-name__wrapper'}
        spaceless
      >
        <Heading
          type={1}
          size={'big'}
          color={'white'}
          additionalClass={'text--light'}
        >
          Digital Shift
        </Heading>
        <Heading
          type={2}
          size={'medium'}
          color={'white'}
          additionalClass={'text--light'}
        >
          {"Boldare's insights on digital product design and development"}
        </Heading>
      </Section>
    );
  }
}

export default BlogName;
